// Centralized news data and helpers

import award from "../assets/award.jpg";
import research from "../assets/coptech.jpeg";
import tech from "../assets/technology.jpeg";
import students from "../assets/studentsInLibrary.jpg";
import cyber from "../assets/cybersecurity.jpg";

const now = Date.now();

export const NEWS = [
  {
    id: 1,
    slug: "new-research-facility-opening",
    title: "New Research Facility Opening",
    description:
      "JRIIT opens a state-of-the-art research facility to foster innovation and groundbreaking research. The facility will house advanced laboratories and collaborative spaces for students and faculty.",
    excerpt:
      "JRIIT opens a state-of-the-art research facility to foster innovation and groundbreaking research...",
    content:
      "The new research facility includes multiple labs, collaborative spaces, and access to industry-grade equipment, empowering students and faculty to drive impactful innovation.",
    image: research,
    featuredImage: research,
    category: "research",
    tags: ["innovation", "development"],
    date: "15 Sep 2024",
    publishedAt: new Date(now - 1000 * 60 * 60 * 24 * 10).toISOString(),
    author: "Dr. Sarah Johnson",
    readTime: "5 min read",
    featured: true,
  },
  {
    id: 2,
    slug: "student-excellence-awards-2025",
    title: "Student Excellence Awards 2025",
    description:
      "Recognizing outstanding student achievements across all faculties for the 2023/2024 academic year. The ceremony celebrated academic excellence, leadership, and community service.",
    excerpt:
      "Recognizing outstanding student achievements across all faculties for the 2023/2024 academic year...",
    content:
      "The Excellence Awards honored students who demonstrated leadership, academic excellence, and dedication to the community across departments.",
    image: award,
    featuredImage: award,
    category: "achievements",
    tags: ["success", "community"],
    date: "12 Sep 2024",
    publishedAt: new Date(now - 1000 * 60 * 60 * 24 * 13).toISOString(),
    author: "Student Affairs Office",
    readTime: "3 min read",
    featured: true,
  },
  {
    id: 3,
    slug: "tech-symposium-2025",
    title: "Tech Symposium 2025",
    description:
      "Join us for a two-day event exploring the latest trends and advancements in the world of technology. Industry experts and researchers will share insights on emerging technologies.",
    excerpt:
      "Join us for a two-day event exploring the latest trends and advancements in the world of technology...",
    content:
      "The symposium features keynotes, workshops, and networking sessions covering AI, cloud, cybersecurity, and more.",
    image: tech,
    featuredImage: tech,
    category: "technology",
    tags: ["innovation", "partnership"],
    date: "10 Sep 2024",
    publishedAt: new Date(now - 1000 * 60 * 60 * 24 * 15).toISOString(),
    author: "Tech Department",
    readTime: "4 min read",
    featured: false,
  },
  {
    id: 4,
    slug: "partnership-with-leading-tech-companies",
    title: "Partnership with Leading Tech Companies",
    description:
      "JRIIT announces strategic partnerships with leading technology companies to provide students with internship opportunities and industry exposure.",
    excerpt:
      "JRIIT announces strategic partnerships with leading technology companies to provide students with internship opportunities...",
    content:
      "The partnerships will create internships, mentorship programs, and real-world project collaborations for students.",
    image:
      "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80",
    featuredImage:
      "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1600&q=80",
    category: "academic",
    tags: ["partnership", "development"],
    date: "08 Sep 2024",
    publishedAt: new Date(now - 1000 * 60 * 60 * 24 * 17).toISOString(),
    author: "Partnership Office",
    readTime: "6 min read",
    featured: false,
  },
  {
    id: 5,
    slug: "new-computer-science-program-launch",
    title: "New Computer Science Program Launch",
    description:
      "We're excited to announce the launch of our new Computer Science program, designed to meet the growing demand for skilled professionals in the technology sector.",
    excerpt:
      "We're excited to announce the launch of our new Computer Science program, designed to meet the growing demand...",
    content:
      "The program features modern curricula in algorithms, systems, and practical software engineering.",
    image:
      "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=800&q=80",
    featuredImage:
      "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=1600&q=80",
    category: "academic",
    tags: ["innovation", "development"],
    date: "05 Sep 2024",
    publishedAt: new Date(now - 1000 * 60 * 60 * 24 * 20).toISOString(),
    author: "Academic Affairs",
    readTime: "4 min read",
    featured: false,
  },
  {
    id: 6,
    slug: "student-innovation-challenge-winners",
    title: "Student Innovation Challenge Winners",
    description:
      "Congratulations to our students who won the regional innovation challenge with their sustainable energy solution project. The team will represent JRIIT at the national level.",
    excerpt:
      "Congratulations to our students who won the regional innovation challenge with their sustainable energy solution project...",
    content:
      "The student team built a novel energy management solution earning top honors at the regional event.",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=800&q=80",
    featuredImage:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1600&q=80",
    category: "achievements",
    tags: ["success", "innovation"],
    date: "03 Sep 2024",
    publishedAt: new Date(now - 1000 * 60 * 60 * 24 * 22).toISOString(),
    author: "Innovation Center",
    readTime: "5 min read",
    featured: false,
  },
  {
    id: 7,
    slug: "faculty-research-grant-success",
    title: "Faculty Research Grant Success",
    description:
      "Three JRIIT faculty members have been awarded prestigious research grants totaling over $500,000 for their innovative projects in renewable energy and AI applications.",
    excerpt:
      "Three JRIIT faculty members have been awarded prestigious research grants totaling over $500,000 for their innovative projects...",
    content:
      "The funded projects span renewable energy systems, AI for social good, and sustainable computing.",
    image:
      "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80",
    featuredImage:
      "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=1600&q=80",
    category: "research",
    tags: ["success", "development"],
    date: "01 Sep 2024",
    publishedAt: new Date(now - 1000 * 60 * 60 * 24 * 24).toISOString(),
    author: "Research Office",
    readTime: "7 min read",
    featured: false,
  },
  {
    id: 8,
    slug: "community-outreach-program",
    title: "Community Outreach Program",
    description:
      "Our students and faculty participated in a community outreach program, providing free computer literacy training to local schools and community centers.",
    excerpt:
      "Our students and faculty participated in a community outreach program, providing free computer literacy training...",
    content:
      "The outreach initiative trained over 300 participants in essential digital skills.",
    image:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80",
    featuredImage:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1600&q=80",
    category: "student-life",
    tags: ["community", "development"],
    date: "30 Aug 2024",
    publishedAt: new Date(now - 1000 * 60 * 60 * 24 * 26).toISOString(),
    author: "Community Service Office",
    readTime: "4 min read",
    featured: false,
  },
  {
    id: 9,
    slug: "alumni-success-stories",
    title: "Alumni Success Stories",
    description:
      "Meet our successful alumni who are making waves in their respective industries. From tech startups to corporate leadership, our graduates continue to excel.",
    excerpt:
      "Meet our successful alumni who are making waves in their respective industries. From tech startups to corporate leadership...",
    content:
      "A selection of alumni profiles showcasing achievements across technology, business, and research.",
    image:
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80",
    featuredImage:
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1600&q=80",
    category: "achievements",
    tags: ["success", "community"],
    date: "28 Aug 2024",
    publishedAt: new Date(now - 1000 * 60 * 60 * 24 * 28).toISOString(),
    author: "Alumni Office",
    readTime: "6 min read",
    featured: false,
  },
  // Items from BreakingNewsUpdates examples
  {
    id: 101,
    slug: "jr-institute-ranked-top-tech-innovation-2025",
    title: "JR Institute Ranked Top for Tech Innovation in 2025",
    excerpt:
      "Our institute has been recognized for excellence in applied research and industry-ready curriculum.",
    description:
      "Our institute has been recognized for excellence in applied research and industry-ready curriculum.",
    content:
      "JR Institute has been ranked among the top institutions for technology innovation in 2025, citing groundbreaking research and robust industry partnerships.",
    priority: "breaking",
    category: "academic",
    tags: ["innovation", "development"],
    publishedAt: new Date(now - 1000 * 60 * 30).toISOString(),
    date: "24 Sep 2025",
    author: "Editorial Board",
    readTime: "5 min read",
    featuredImage: tech,
    image: tech,
    featured: true,
  },
  {
    id: 102,
    slug: "admissions-open-short-courses-oct-session",
    title: "Admissions Open: Short Courses Intake (Oct Session)",
    excerpt:
      "Enroll now for industry-driven short courses. Flexible schedules and certification included.",
    description:
      "Enroll now for industry-driven short courses. Flexible schedules and certification included.",
    content:
      "Our short courses are designed with input from industry leaders to ensure job-ready skills.",
    priority: "urgent",
    category: "academic",
    tags: ["innovation", "development"],
    publishedAt: new Date(now - 1000 * 60 * 90).toISOString(),
    date: "23 Sep 2025",
    author: "Admissions Office",
    readTime: "3 min read",
    featuredImage: students,
    image: students,
    featured: true,
  },
  {
    id: 103,
    slug: "cybersecurity-bootcamp-final-call",
    title: "Cybersecurity Bootcamp: Final Call for Applications",
    excerpt:
      "Hands-on bootcamp led by industry experts. Limited seats available.",
    description:
      "Hands-on bootcamp led by industry experts. Limited seats available.",
    content:
      "A comprehensive, practical bootcamp covering network security, ethical hacking, and forensics.",
    priority: "update",
    category: "technology",
    tags: ["innovation", "partnership"],
    publishedAt: new Date(now - 1000 * 60 * 60 * 5).toISOString(),
    date: "24 Sep 2025",
    author: "Cybersecurity Dept.",
    readTime: "4 min read",
    featuredImage: cyber,
    image: cyber,
    featured: false,
  },
  {
    id: 104,
    slug: "scholarship-interviews-next-week",
    title: "Scholarship Interviews Scheduled for Next Week",
    excerpt:
      "Eligible applicants will receive email notifications with interview slots.",
    description:
      "Eligible applicants will receive email notifications with interview slots.",
    content:
      "Interviews will be conducted by a panel comprising faculty and industry partners.",
    priority: "normal",
    category: "achievements",
    tags: ["success", "community"],
    publishedAt: new Date(now - 1000 * 60 * 60 * 26).toISOString(),
    date: "23 Sep 2025",
    author: "Scholarship Committee",
    readTime: "6 min read",
    featuredImage: students,
    image: students,
    featured: false,
  },
];

export function getNewsList() {
  return NEWS;
}

export function getNewsById(id) {
  const numeric = Number(id);
  return NEWS.find((n) => n.id === numeric);
}
